
export const curChatUserId = state => state.curChatUserId;

export const tencentLogined = state => state.tencentLogined;

export const userMap = state => state.userMap;

export const unreadMsgNum = state => state.unreadMsgNum;

export const newMsg = state => state.newMsg;

export const groupList = state => state.groupList;






// WEBPACK FOOTER //
// ./src/store/getters.js